import { BaseItem, FindAll } from '../common';
import { Kind } from '../notification/content';

export enum Status {
  Processing = 'PROCESSING',
  Failed = 'FAILED',
  Success = 'SUCCESS',
}

export enum NotSentReason {
  DuplicateNotification = 'DUPLICATE_NOTIFICATION',
  EmailNotificationsNotEnabled = 'EMAIL_NOTIFICATIONS_NOT_ENABLED',
  EncounterDeleted = 'ENCOUNTER_DELETED',
  FailedResponseFromSendgrid = 'FAILED_RESPONSE_FROM_SENDGRID',
  IntakeNotEnabled = 'INTAKE_NOT_ENABLED',
  InvalidContactPreference = 'INVALID_CONTACT_PREFERENCE',
  InvalidContactSequence = 'INVALID_CONTACT_SEQUENCE',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidIntent = 'INVALID_INTENT',
  InvalidMessagingTime = 'INVALID_MESSAGING_TIME',
  InvalidTemplate = 'INVALID_TEMPLATE',
  InvalidUrlParam = 'INVALID_URL_PARAM',
  IsHoliday = 'IS_HOLIDAY',
  MissingNotificationReason = 'MISSING_NOTIFICATION_REASON',
  NoConsentToMessagePatient = 'NO_CONSENT_TO_MESSAGE_PATIENT',
  NoEmail = 'NO_EMAIL',
  NoEmailTemplate = 'NO_EMAIL_TEMPLATE',
  NoImplementation = 'NO_IMPLEMENTATION',
  NoMorePhoneNumbers = 'NO_MORE_PHONE_NUMBERS',
  NoResponseFromTwilio = 'NO_RESPONSE_FROM_TWILIO',
  NoSmsTemplate = 'NO_SMS_TEMPLATE',
  NoValidPhoneNumbers = 'NO_VALID_PHONE_NUMBERS',
  NoVoiceTemplate = 'NO_VOICE_TEMPLATE',
  PastEncounterStartTime = 'PAST_ENCOUNTER_START_TIME',
  PatientAgeInvalid = 'PATIENT_AGE_INVALID',
  RateLimited = 'RATE_LIMITED',
  RecentMessageSent = 'RECENT_MESSAGE_SENT',
  UnknownSolution = 'UNKNOWN_SOLUTION',
}

interface BaseValues {
  kind: Kind;
  practiceId: string;
  status: Status;
  broadcastId: string | null;
  encounterId: string | null;
  notificationConfigId: string | null;
  notificationContentId: string | null;
  patientId: string | null;
  provisionalPatientId: string | null;
  previsitFormSetId: string | null;
  undeliveredReason: NotSentReason | null;
}

export interface Request extends BaseItem, BaseValues {}

export interface RequestPopulated extends Request {
  firstName: string;
  lastName: string;
  phoneNumber: string | null;
  email: string | null;
}

interface SendStatus {
  contact: string | null;
  kind: Kind;
  status: Status | null;
}

export interface GroupedResult
  extends Pick<
    RequestPopulated,
    'practiceId' | 'encounterId' | 'broadcastId' | 'firstName' | 'lastName'
  > {
  patientId: string;
  statuses: SendStatus[];
}

export type FindAllOptions = FindAll<
  Pick<
    Request,
    | 'id'
    | 'patientId'
    | 'provisionalPatientId'
    | 'practiceId'
    | 'encounterId'
    | 'broadcastId'
    | 'previsitFormSetId'
    | 'status'
    | 'notificationConfigId'
    | 'notificationContentId'
  >,
  BaseItem & BaseValues
>;
